import { fetchFxRates } from '@pequity/shared/api/fxRates';
import { currencies } from '@pequity/shared/utils/currencies';
import { defineStore } from 'pinia';

export const useCurrencyStore = defineStore('currency', {
  state: () => ({
    fxRates: {} as Record<string, number>,
  }),
  getters: {
    supportedCurrencyCodes: (state) => {
      return Object.keys(state.fxRates);
    },
    isSupportedCurrencyCode: (state) => (currencyCode: string) => {
      return currencyCode in state.fxRates;
    },
    getConvertedValueToUSD: (state) => (value: number, fromCurrencyCode: string) => {
      if (fromCurrencyCode === 'USD') {
        return value;
      }
      const rate = state.fxRates[fromCurrencyCode];
      return rate ? value / rate : value;
    },
    getConvertedValueFromUSD: (state) => (value: number, toCurrencyCode: string) => {
      if (toCurrencyCode === 'USD') {
        return value;
      }
      const rate = state.fxRates[toCurrencyCode];
      return rate ? value * rate : value;
    },
  },
  actions: {
    async fetchFxRates() {
      if (Object.keys(this.fxRates).length) {
        return;
      }

      const { data } = await fetchFxRates();
      for (const code in data) {
        if (code in currencies) {
          this.fxRates[code] = data[code];
        }
      }
    },
  },
});
